import { getFirebaseAnalytics } from "@/config/firebase";
import { logEvent, setUserId, setUserProperties } from "firebase/analytics";

/**
 * Firebase Analytics에 에러 이벤트를 기록한다.
 * Analytics가 초기화되지 않은 경우(에뮬레이터 모드 등) 무시한다.
 */
export function trackError(error: unknown, context?: Record<string, string>): void {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;

  const errorInfo =
    error instanceof Error
      ? { error_name: error.name, error_message: error.message.slice(0, 100) }
      : { error_name: "Unknown", error_message: String(error).slice(0, 100) };

  logEvent(analytics, "app_error", {
    ...errorInfo,
    ...context,
    timestamp: new Date().toISOString(),
  });
}

/**
 * 에러 추적에 사용자 컨텍스트를 설정한다.
 * Analytics가 초기화되지 않은 경우(에뮬레이터 모드 등) 무시한다.
 */
export function setErrorTrackingUser(uid: string, role: string): void {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;

  setUserId(analytics, uid);
  setUserProperties(analytics, { user_role: role });
}
